import React from "react";
import "./SpecsListItem.sass";

const SpecsListItem = ({ name, value }) => {
  console.log(typeof value);
  return (
    <div className="specs-list-item">
      <div>
        <p>{name}</p>
      </div>
      {typeof value == "object" ? null : (
        <div>
          <p>{value}</p>
        </div>
      )}
    </div>
  );
};

export default SpecsListItem;
